import React, { useState } from 'react';
import { authService } from '../services/api';

export default function LoginForm({ onSuccess, onSwitch }) {
  const [telephone, setTelephone] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.login(telephone, motDePasse);
      if (onSuccess) onSuccess();
    } catch (err) {
      setError(err.message || 'Échec de la connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ag-auth-page">
      <div className="ag-card ag-auth-card">
        <div className="ag-auth-header">
          <div className="ag-auth-badge">🔐</div>
          <div>
            <h2>Se connecter</h2>
            <p className="ag-login-note">Administrateur, vendeur ou client : utilisez votre identifiant professionnel ou votre numéro de téléphone pour accéder à votre interface dédiée.</p>
          </div>
        </div>

        <form className="ag-form" onSubmit={handleSubmit}>
          <label>
            Identifiant / Téléphone
            <input
              type="text"
              value={telephone}
              onChange={(e) => setTelephone(e.target.value)}
              placeholder="Téléphone ou nom d'utilisateur"
              required
            />
          </label>

          <label>
            Mot de passe
            <input
              type="password"
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              placeholder="Mot de passe"
              required
            />
          </label>

          {/* no persistent remember-me: we use HttpOnly cookie for refresh token and in-memory access token */}

          {error && <div className="ag-alert ag-alert-error">{error}</div>}

          <button className="ag-btn ag-auth-submit" type="submit" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div className="ag-form-footer ag-auth-footer">
          <span>Vous n'avez pas de compte ?</span>
          <button type="button" className="ag-btn-secondary" onClick={onSwitch}>
            S'inscrire
          </button>
        </div>
      </div>
    </div>
  );
}
